// fix/pwa-error-boundary -- pure-JS error-detection helpers, no React.
//
// Extracted into its own module so `node --test` can exercise it
// directly without a JSX loader. The JSX files (ErrorBoundary.jsx,
// ChunkLoadBanner.jsx) import from here.

// Returns true when err looks like a Vite/Rollup dynamic-import or
// chunk-load failure. Typical trigger: Render redeployed + the running
// tab still holds an index.html referencing a hashed asset that no
// longer exists on the server.
//
// Browser message signatures (Chrome/Firefox/Safari/Edge):
//   "Failed to fetch dynamically imported module: https://.../assets/foo-<hash>.js"
//   "Loading chunk 3 failed."
//   "Loading CSS chunk 5 failed."
//   "Importing a module script failed."
//
// Safe against null/undefined/non-Error inputs (returns false).
export function isChunkLoadError(err) {
  if (!err) return false;
  let text = "";
  try {
    text = (err.message || (typeof err.toString === "function" ? err.toString() : "") || "").toString();
  } catch { return false; }
  if (!text) return false;
  text = text.toLowerCase();
  return (
    /failed to fetch dynamically imported module/.test(text) ||
    /loading chunk \d+ failed/.test(text) ||
    /loading css chunk \d+ failed/.test(text) ||
    /importing a module script failed/.test(text)
  );
}
